// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    urlApi: 'https://ticketpro.ca/api/',
    log: {
        active: true,
        NB: 0,
        random: 0
    },
    defaultLocale: 'en',
    basePath: '/',
    systemValues: 'tkp',
    urlGwt: '',
    oldFlow: false,
    splitPrice: false,
    oldCheckout: false,
    apiUrlHorizonB4: 'https://plateforme.brite4.com',
    color: {
        primary: '#121944',
        accent: '#E6322D',
        warn: '#ffa814',
        text: '#FFF',
        Background: '#FFF'
    },
    recaptcha: {
        siteKey: '',
        active: false
    },
    googlePay:{
        gateway: 'globalpayments',
        gatewayMerchantId: 'ticketproinc'
    },
    applePay:{
        merchantIdentifier: 'merchant.ca.ticketpro',
        displayName: 'Ticketpro Inc.',
        initiative: 'web',
        initiativeContext: ''
    },
    /**  Pour que Google Pay et Apple Pay fonctionnent, il est nécessaire de rediriger vers un sous-domaine checkout.ticketpro.ca */
    checkout:true,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
